import React from 'react';
import { useDispatch } from 'react-redux';

import { icon, title, wrapper, avatar } from './single-video-opinion.module.scss';
import YoutubeRedIcon from '../../assets/images/svg/youtube-red.svg';
import { addModalAction } from '../../redux/actions/actions-modals';

import Avatar from '../atoms/avatar';
import VideoModal from '../organisms/custom-modals/video-modal';
import Markdown from '../hoc/markdown';

const SingleVideoOpinion = ({ video: { videoUrl, content, author } }) => {
    const dispatch = useDispatch();

    const handlePlayClick = () => {
        dispatch(
            addModalAction({
                fullWidth: true,
                renderComponent: (modalId) => <VideoModal modalId={modalId} videoUrl={videoUrl} />,
            })
        );
    };

    return (
        <button className={wrapper} onClick={handlePlayClick}>
            <div className={avatar}>
                <Avatar size="large" avatarUri={author.imageUrl} alt={author.name} />
            </div>
            {author.name}
            <div className={title}>
                <Markdown className={'ck-content'}>{content}</Markdown>
            </div>
            <YoutubeRedIcon className={icon} />
        </button>
    );
};

export default SingleVideoOpinion;
